import * as React from 'react';
import { LocalizationContext } from '../Localization/LocalizationContext';
/**
 * @hidden
 */
export var useLocalization = function () { return React.useContext(LocalizationContext); };
//# sourceMappingURL=useLocalization.js.map